export default "__VITE_ASSET__93rTULS1__"